var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Component, Prop, Vue } from 'vue-property-decorator';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { addClass, removeClass } from '@/support/Html';
import { identifyApplication, identifyHostname, isLocal } from '@/support/Client';
import { Token } from '@/support/Token';
import axios from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { User } from '@/models/User';
import { Group } from '@/models/Group';
import { Project } from '@/models/Project';
let DownloadIdpDialog = class DownloadIdpDialog extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.selectedSubjects = [];
        this.selectedProject = null;
        this.message = '';
        this.isDownloaded = false;
        this.isSelectAll = true;
        this.downloadUrl = '';
    }
    get projects() {
        // TODO
        if (this.group && this.group.projects) {
            return [this.group.projects];
        }
        if (this.user && this.user.projects) {
            return this.user.projects;
        }
        return [];
    }
    get selectAllSubjects() {
        if (this.selectedSubjects.length !== this.subjects.length) {
            return false;
        }
        return this.isSelectAll;
    }
    set selectAllSubjects(value) {
        if (this.selectedSubjects.length === this.subjects.length) {
            this.isSelectAll = true;
            return;
        }
        this.isSelectAll = value;
    }
    get isDisabled() {
        return !this.selectedSubjects || !this.selectedSubjects.length;
    }
    initialize() {
        const body = document.querySelectorAll('body')[0];
        addClass(body, 'bodyNoScroll');
        this.selectAll();
    }
    submit() {
        this.downloadFileBlob();
    }
    destroyed() {
        const body = document.querySelectorAll('body')[0];
        removeClass(body, 'bodyNoScroll');
    }
    mounted() {
        if (this.defaultSelectedProject) {
            this.selectedProject = this.defaultSelectedProject.id;
        }
        this.initialize();
    }
    selectAll() {
        this.selectedSubjects = this.subjects.map((subject) => {
            return subject.id || '';
        });
    }
    downloadFileBlob() {
        this.isLoading = true;
        const API = `${identifyHostname()}`;
        const headers = {
            'Accept': 'application/pdf',
            'Content-type': 'application/json',
        };
        if (isLocal()) {
            headers['X-Application'] = identifyApplication();
        }
        if (Token.get()) {
            headers.Authorization = `Bearer ${Token.get()}`;
        }
        const client = axios.create({
            baseURL: API,
            headers,
            ...this.user ? { responseType: 'blob' } : {},
        });
        let url = `/v3/student-idp-download/?with[]=parent&with[]=area&with[]=level&with[]=period&with[]=template`;
        if (this.$route.query.statuses) {
            const statuses = [];
            const parsedStatuses = typeof this.$route.query.statuses === 'string' ? [this.$route.query.statuses] : this.$route.query.statuses;
            parsedStatuses.forEach((status) => {
                statuses.push(`&filters[statuses][]=${status}`);
            });
            url = `${url}${statuses.join('')}`;
        }
        if (this.$route.query.levels) {
            const levels = [];
            const parsedLevels = typeof this.$route.query.levels === 'string' ? [this.$route.query.levels] : this.$route.query.levels;
            parsedLevels.forEach((level) => {
                levels.push(`&filters[levels][]=${level}`);
            });
            url = `${url}${levels.join('')}`;
        }
        if (this.$route.query.periods) {
            const periods = [];
            const parsedPeriods = typeof this.$route.query.periods === 'string' ? [this.$route.query.periods] : this.$route.query.periods;
            parsedPeriods.forEach((period) => {
                periods.push(`&filters[periods][]=${period}`);
            });
            url = `${url}${periods.join('')}`;
        }
        if (this.selectedSubjects.length) {
            const areas = [];
            this.selectedSubjects.forEach((subject) => {
                areas.push(`&filters[areas][]=${subject}`);
            });
            url = `${url}${areas.join('')}`;
        }
        if (this.user) {
            url = `${url}&filters[users][]=${this.user.id}`;
        }
        if (this.group) {
            url = `${url}&filters[group]=${this.group.id}`;
        }
        if (this.selectedProject) {
            url = `${url}&filters[projects]=${this.selectedProject}`;
            // //('selected proe', this.selectedProject)
        }
        client
            .get(url)
            .then((response) => {
            if (this.user) {
                this.isDownloaded = true;
                this.isLoading = false;
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                const disposition = response.request.getResponseHeader('Content-Disposition');
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                let name = '';
                if (matches != null && matches[1]) {
                    name = matches[1].replace(/['"]/g, '');
                }
                link.setAttribute('download', name);
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(url);
                link.remove();
                this.close();
            }
            if (this.group) {
                this.message = this.$t(`${response.data.message}`).toString();
                this.isDownloaded = true;
                this.isLoading = false;
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.isLoading = false;
        });
    }
    close() {
        this.$emit('input', false);
    }
    toggleSelectAll(value) {
        if (!value) {
            this.selectedSubjects = [];
            return;
        }
        this.selectAll();
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Array)
], DownloadIdpDialog.prototype, "subjects", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof User !== "undefined" && User) === "function" ? _a : Object)
], DownloadIdpDialog.prototype, "user", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof Group !== "undefined" && Group) === "function" ? _b : Object)
], DownloadIdpDialog.prototype, "group", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_c = typeof Project !== "undefined" && Project) === "function" ? _c : Object)
], DownloadIdpDialog.prototype, "defaultSelectedProject", void 0);
DownloadIdpDialog = __decorate([
    Component({
        components: {
            LoaderCard,
        },
    })
], DownloadIdpDialog);
export default DownloadIdpDialog;
